var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"disabled":_vm.disabled,"value":_vm.searchText,"append-icon":"mdi-magnify","color":"deep-purple accent-2","outlined":"","dense":"","label":"Search","hide-details":""},on:{"input":_vm.search},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }